import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardTitle,
  CardText,
  UncontrolledTooltip,
} from "reactstrap";
import { FaCog } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  getAdminStats,
  getAdminStatsPartOne,
  getAdminStatsPartTwo,
  getUserDashboardWidget,
} from "http/UAM/userDashboardWidget.helper";
import { Link } from "react-router-dom";
import StatsCard from "../../components/StatsCard";
import Top5Fin from "components/Top5Fin";
import DealStatus from "components/DealStatus";
import DealsCreated from "components/DealsCreated";
import UserAssigned from "components/UserAssigned";
import Top5Cus from "components/Top5Cus";
import GetEntityByOwners from "components/EntityByOwners";
import GetEntityByPdtAndServices from "components/EntityByPdt&Services";
import CusOnboarded from "components/CusOnboarded";
import { PendingTasks, OverdueTasks } from "components/DashboardTasks"
import { decryptedValue, isPermission } from "common/utility";
import DataTable from "components/Table";
import { AiFillDashboard, AiOutlineRight } from 'react-icons/ai';

const CustomerDashboardV1 = (props) => {
  document.title = "Dashboard | FundLync";
  const [role, setRole] = useState(null);
  const [adminStatsData, setAdminStatsData] = useState([]);
  const [adminStatsDataPartOne, setAdminStatsDataPartOne] = useState([]);
  const [adminStatsDataPartTwo, setAdminStatsDataPartTwo] = useState([]);
  const [permissions, setPermissions] = useState({
    admin_stats: 1,
    deal_status: 1,
    top_customer: 1,
    top_financier: 1,
    task_widget: 1,
    customer_onboarded: 1,
    monthwise_deal_created: 1,
    deal_assign_ci: 0,
    entity_by_owner: 1,
    entity_by_pdt_and_services: 1,
    deal_stats: 1,
    entity_stats	: 1
  });
  const user = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    getUserDashboardWidget({ userId: user.id })
      .then((response) => {
        if (response.status) {
          checkUserDashboardWidgets(response.data?.rows[0]?.dashboardWidgets);
        } else {
          checkPermissions();
        }
      })
      .catch((error) => {
        console.error(error);
      });
    getAdminStats({ user })
      .then((res) => {
        if (res.status) {
          setAdminStatsData(res.data);
        } else {
          setAdminStatsData([]);
        }
      })
      .catch((err) => console.error(err, "err"));
    getAdminStatsPartOne({ user })
      .then((res) => {
        if (res.status) {
          setAdminStatsDataPartOne(res.data);
        } else {
          setAdminStatsDataPartOne([]);
        }
      })
      .catch((err) => console.error(err, "err"));
    getAdminStatsPartTwo({ user })
      .then((res) => {
        if (res.status) {
          setAdminStatsDataPartTwo(res.data);
        } else {
          setAdminStatsDataPartTwo([]);
        }
      })
      .catch((err) => console.error(err, "err"));
    if (user) {
      setTimeout(() => {
        setRole(user.roleName);
      }, 100);
    }
  }, []);

  const checkUserDashboardWidgets = (userDashboardWidgetList) => {
    const admin_stats = userDashboardWidgetList.admin_stats === 1;
    const deal_assign_ci =
      userDashboardWidgetList.deal_assigned_to_CI_users === 1;
    const deal_status = userDashboardWidgetList.deal_status === 1;
    const top_customer = userDashboardWidgetList.top_customer === 1;
    const task_widget = userDashboardWidgetList.task_widget === 1;
    const top_financier = userDashboardWidgetList.top_financier === 1;
    const customer_onboarded = userDashboardWidgetList.customer_onboarded === 1;
    const monthwise_deal_created =
      userDashboardWidgetList.monthwise_deal_created === 1;
    const entity_by_owner = userDashboardWidgetList.entity_by_owner === 1;
    const entity_by_pdt_and_services = userDashboardWidgetList.entity_by_pdt_and_services === 1;
    const deal_stats = userDashboardWidgetList.deal_stats === 1;
    const entity_stats = userDashboardWidgetList.entity_stats === 1;
    setPermissions({
      admin_stats,
      deal_status,
      top_customer,
      task_widget,
      top_financier,
      customer_onboarded,
      monthwise_deal_created,
      deal_assign_ci,
      entity_by_owner,
      entity_by_pdt_and_services,
      deal_stats,
      entity_stats,
    });
    
  };
  const checkPermissions = async () => {
    const admin_stats = await isPermission("admin_stats", "view_permission");
    const deal_assign_ci = await isPermission(
      "deal_assigned_to_CI_users",
      "view_permission"
    );
    const deal_status = await isPermission("deal_status", "view_permission");
    const top_customer = await isPermission("top_customer", "view_permission");
    const task_widget = await isPermission("task_widget", "view_permission")
    const top_financier = await isPermission(
      "top_financier",
      "view_permission"
    );
    const customer_onboarded = await isPermission(
      "customer_onboarded",
      "view_permission"
    );
    const monthwise_deal_created = await isPermission(
      "monthwise_deal_created",
      "view_permission"
    );
    const deal_stats = await isPermission("deal_stats", "view_permission")
    const entity_stats = await isPermission("entity_stats", "view_permission")
    const entity_by_owner = await isPermission("entity_by_owner", "view_permission")
    const entity_by_pdt_and_services = await isPermission("entity_by_pdt_and_services", "view_permission")
    setPermissions({
      admin_stats,
      deal_status,
      top_customer,
      task_widget,
      top_financier,
      customer_onboarded,
      monthwise_deal_created,
      deal_assign_ci,
      deal_stats,
      entity_stats,
      entity_by_owner,
      entity_by_pdt_and_services
    });
  };

  const mergedData = adminStatsData?.map((item, index) => {
    return {
      displayName: adminNumberData[index].label,
      value: item.value,
      color: adminNumberData[index].color,
      url: item.url,
    };
  });
  const mergedDataPartOne = adminStatsDataPartOne?.map((item, index) => {
    return {
      displayName: item.displayName,
      displayText: item.displayText,
      value: item.value,
      url: item.url
    };
  });
  const mergedDataPartTwo = adminStatsDataPartTwo?.map((item, index) => {
    return {
      displayName: item.displayName,
      value: item.value,
      displayText: item.displayText
    };
  });

  return (
    <div>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4
                  style={{ marginLeft: "1.2rem" }}
                  className="mb-sm-0 font-size-18"
                >
                  Dashboard
                </h4>
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className="mb-2"
                >
                  <Link to={`/${user.roleName}/widgetSetting`}>
                    <FaCog
                      size={20}
                      className="smooth-icon"
                      style={{ color: "#34c38f", transition: "all 0.3s ease" }}
                    />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          <div className="vertical-scroll">
            {!!permissions.admin_stats && (
              <Row className="custom-row" style={{ marginBottom: "1rem" }}>
                {mergedData?.map((i, index) => (
                  <Col
                    style={{ marginTop: "-1rem" }}
                    key={`${i.id}-${index}`}
                    lg={3}
                  >
                    {role ? (
                      <StatsCard
                        color={i.color}
                        label={i?.displayName}
                        value={
                          <span
                            style={{
                              fontWeight: 600,
                              fontSize: "1.5rem",
                              color: "#495057",
                            }}
                          >
                            {i?.value.toString()}
                          </span>
                        }
                        url={i?.url}
                      />
                    ) : (
                      <Skeleton
                        key={`${i.id}-${index}-skeleton`}
                        height={40}
                        count={5}
                      />
                    )}
                  </Col>
                ))}
              </Row>
            )}
            {/* ****** Entity by Owner ******/}
            <Row>
              {!!permissions.entity_by_owner && (
                <Col lg={6}>
                  <GetEntityByOwners />
                </Col>
              )}
              {/****** 2*3 GRID *******/}
              {!!permissions.entity_stats && (
                <Col
                  lg={6}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  {mergedDataPartOne &&
                    [0, 2, 4].map((startIdx) => (
                      <Row key={startIdx}>
                        {mergedDataPartOne
                          .slice(startIdx, startIdx + 2)
                          .map((i, index) => (
                            <Col
                              key={`${i.id}-${index}`}
                              style={{ marginBottom: "0px" }}
                              sm="12"
                              lg="6"
                            >
                              {role ? (
                                <Card style={{ maxHeight: "120px" }}>
                                  <CardBody style={{ borderRadius: "20px" }}>
                                    <CardTitle
                                      tag="h2"
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.displayName}
                                      <i
                                        className="bx bx-info-circle font-size-14 pl-3"
                                        id={i.displayName.split(" ").join("-")}
                                        style={{
                                          cursor: "pointer",
                                          paddingLeft: "2px",
                                        }}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={i.displayName
                                          .split(" ")
                                          .join("-")}
                                      >
                                        {i.displayText}
                                      </UncontrolledTooltip>
                                    </CardTitle>
                                    <h2
                                      style={{
                                        fontWeight: 600,
                                        fontSize: "1.5rem",
                                      }}
                                    >
                                      {i.value}
                                    </h2>
                                    {i?.url && (
                                      <Link
                                        to={i?.url}
                                        className={`text-success font-weight-bold`}
                                      >
                                        Details{" "}
                                        <AiOutlineRight
                                          style={{
                                            fontSize: "15px",
                                            verticalAlign: "text-bottom",
                                            marginLeft: "5px",
                                          }}
                                        />
                                      </Link>
                                    )}
                                  </CardBody>
                                </Card>
                              ) : (
                                <Skeleton
                                  key={`${i.id}-${index}-skeleton`}
                                  count={5}
                                />
                              )}
                            </Col>
                          ))}
                      </Row>
                    ))}
                </Col>
              )}
            </Row>
            {/******* Entity by P&S ***** */}
            <Row>
              {!!permissions.entity_by_pdt_and_services && (
                <Col lg={6}>
                  <GetEntityByPdtAndServices />
                </Col>
              )}
              {!!permissions.deal_stats && (
                <Col>
                  <ul className="list-unstyled">
                    {mergedDataPartTwo?.map((i, index) => (
                      <li key={`${i.id}-${index}`} className="pb-1" style={{}}>
                        {role ? (
                          <div
                            className="pt-2 p-2 d-flex align-items-center justify-content-between"
                            style={{
                              border: "1.2px solid #CCCCCC",
                              borderRadius: "2px",
                            }}
                          >
                            <div
                              className="fs-5 fw-bold"
                              style={{ paddingBottom: "3.6px" }}
                            >
                              {i.displayName}
                              <i
                                className="bx bx-info-circle font-size-11 pl-3 me-1"
                                id={i.displayName.split(" ").join("-")}
                                style={{
                                  cursor: "pointer",
                                  padding: "10px 5px",
                                  marginRight: "5px",
                                }}
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={i.displayName.split(" ").join("-")}
                              >
                                {i.displayText}
                              </UncontrolledTooltip>
                            </div>
                            <div
                              className="ml-2 fs-3"
                              style={{ fontWeight: 600, fontSize: "1.5rem" }}
                            >
                              {i.value}
                            </div>
                          </div>
                        ) : (
                          <div className="border border-2 p-3">
                            <Skeleton width={100} height={40} />
                            <Skeleton width={50} height={40} className="ml-3" />
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </Col>
              )}
            </Row>
            <Row>
              {!!permissions.task_widget && (
                <Col lg={6}>
                  <PendingTasks />
                </Col>
              )}
              {!!permissions.task_widget && (
                <Col lg={6}>
                  <OverdueTasks />
                </Col>
              )}
            </Row>
            <Row style={{ marginBottom: "1rem" }}>
              {/* Deals Created */}
              {!!permissions.monthwise_deal_created && (
                <Col lg={6}>
                  {role ? (
                    <div className="equal-height">
                      <DealsCreated userType={role} />
                    </div>
                  ) : (
                    <>
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    </>
                  )}
                </Col>
              )}
              {/* Deal Status */}
              {!!permissions.deal_status && (
                <Col lg={6}>
                  {role ? (
                    <div className="equal-height">
                      <DealStatus
                        userType={role}
                        dataColors='["--bs-success", "--bs-danger","--bs-warning", "--bs-info", "#ffa500", "#8a2be2",  "#556ee6", "#ff8bb8"]'
                      />
                    </div>
                  ) : (
                    <>
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    </>
                  )}
                </Col>
              )}
              {/* Deals Assigned to CI Users */}
              {!!permissions.deal_assign_ci && (
                <Col lg={6}>
                  <>
                    {role ? (
                      <UserAssigned />
                    ) : (
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    )}
                  </>
                </Col>
              )}
              {!!permissions.top_financier && (
                <Col lg={6}>
                  <>
                    {role ? (
                      <Top5Fin />
                    ) : (
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    )}
                  </>
                </Col>
              )}
              {/* Top 5 Customers */}
              {!!permissions.top_customer && (
                <Col lg={6}>
                  <Top5Cus />
                </Col>
              )}
              {/* Number of Customers Onboard */}
              {!!permissions.customer_onboarded && (
                <Col lg={6}>
                  <CusOnboarded />
                </Col>
              )}
            </Row>
            {/* Bottom Two Tables */}
            <Row>
              <Col style={{ minHeight: "18.8rem" }} lg={6}>
                {!!permissions.top_financier && <DataTable type="financiers" />}
              </Col>
              <Col style={{ minHeight: "18.8rem" }} lg={6}>
                {!!permissions.top_customer && <DataTable type="customers" />}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

const adminNumberData = [
  {
    id: 1,
    label: "Entities",
    value: 55,
    color: "info",
  },
  {
    id: 2,
    label: "Customers",
    value: 125,
    color: "success",
  },
  {
    id: 3,
    label: "Financiers",
    value: 33,
    color: "warning",
  },
  {
    id: 4,
    label: "Deals",
    value: 300,
    color: "success",
  },
];

export default CustomerDashboardV1;
